import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import ShareType from "../../../Models/Catalogue/General/ShareType";
import { Catalogue } from "@singularsystems/neo-react-services";

export default class ShareTypeCatalogueEntry extends CatalogueEntry<ShareType> {

    constructor() {
        super("Share Types", ShareType);
    }

    public get editRole() {
        return CatalogueRoles.ShareTypes.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.shareTypes;
    }
    
    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveShareTypes;
    }
    
    public renderRow(item: ShareType, meta: Model.TransformMetaType<ShareType>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.shareTypeName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}